import {
  QueryFunctionContext,
  useQueries,
  useQuery,
} from '@tanstack/react-query';
import { getAuthenticated, getWithUnauthenticatedCredentials } from './api';
import { PropertySearchBase64Image } from '../models/search.models';
import { FavoriteProperties } from '../models/favorites.model';
import { AuthUser } from 'aws-amplify/auth';
import { propertySearch, PropertySearchResTypeData } from '../services/api';

export const useGetLandSearchGooglePhoto = (
  searchResponse: PropertySearchResTypeData | undefined,
  user?: AuthUser | undefined | null
) => {
  const url = `land/image?latitude=${searchResponse?.latitude}&longitude=${searchResponse?.longitude}`;
  const { isPending, error, data, refetch } =
    useQuery<PropertySearchBase64Image>({
      queryKey: ['land-image', searchResponse?.id || ''],
      enabled:
        !!searchResponse?.id &&
        !searchResponse?.primaryListingImageUrl &&
        !!searchResponse?.latitude &&
        !!searchResponse?.longitude,
      queryFn: async () => {
        if (user?.userId) {
          return getAuthenticated<PropertySearchBase64Image>(url);
        }
        return getWithUnauthenticatedCredentials<PropertySearchBase64Image>(
          url
        );
      },
    });

  return {
    loading: isPending,
    error,
    data: data || undefined,
    refetch,
  };
};

export const useGetFavoriteResults = (favorites: FavoriteProperties[]) => {
  return useQueries({
    queries:
      favorites &&
      favorites.map((search) => ({
        enabled: !!search,
        queryKey: ['favorite-results', search],
        queryFn: ({ signal }: QueryFunctionContext) => {
          const addressWithId = { ...search.address, id: search.id };
          return propertySearch({
            signal,
            body: addressWithId,
          });
        },
        staleTime: 0,
      })),
    combine: (results) => {
      const res = results.map((result) => result.data?.data[0]);
      const combinedData = res.map((result) => {

        return {
          ...result,
        } as PropertySearchResTypeData;
      });
      return {
        data: combinedData,
        pending: results.some((result) => result.isPending),
      };
    },
  });
};
